import React from 'react';
import { View, ViewProps } from 'react-native';
import useStyles from './TabBar.styles';

export type TabBarProps = ViewProps & {
  shadow?: boolean;
};

export const TabBar: React.FC<TabBarProps> = ({ children, style, shadow = true }) => {
  const s = useStyles();

  return (
    <View style={[s.root, shadow && s.shadow, style]} accessibilityRole="tablist">
      {children}
    </View>
  );
};
